import { useTranslation } from 'react-i18next';

// Wrapper to maintain compatibility with existing useI18n usage
export const useI18n = () => {
  const { t } = useTranslation();
  return t;
};

// Optional: For scoped translations if needed
export const useScopedI18n = (scope) => {
  const { t } = useTranslation();
  return (key) => t(`${scope}.${key}`);
};
